// @flow

/*eslint-disable */
import 'rebrandStyle.global'
/*eslint-enable */

import dotenv from 'dotenv'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ThemeProvider, ThemeNuInvestRebrand } from 'easyguide'
import createSagaMiddleware from 'redux-saga'

import rootSaga from 'sagas'
import theme from 'config/themes'
import Routes from 'components/Routes'
import configureStore from 'store/configureStore'
import '@greg/button'
import '@greg/nav-button'
import '@greg/progress-bar'
import '@greg/tooltip'
import '@greg/inputText'
import '@greg/icon'
import '@greg/icon-link'
import '@greg/radio-button'
import '@greg/accordion'
import '@greg/requirements'
import '@greg/warning'
import '@greg/action-chip'
import '@greg/select-option'
import '@easynvest/greg'

dotenv.config()

const sagaMiddleware = createSagaMiddleware()
const store = configureStore(sagaMiddleware)
sagaMiddleware.run(rootSaga)


const Application = () => (
  <ThemeProvider theme={{ ...ThemeNuInvestRebrand, ...theme }}>
    <Provider store={store}>
      <Routes />
    </Provider>
  </ThemeProvider>
)
if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    if (registrations.length) {
      registrations.forEach(registration => {
        registration.unregister()
      })
    }
  })
}

ReactDOM.render(<Application />, document.getElementById('app'))
